import './styles.css';

export default function Team({ color, name }) {
  return (
    <div className="tournament-students-info tournament-students-team" data-tour-id="user-team">
      <span className="tournament-team-indicator" style={{backgroundColor: color}}></span>
      <span>Team: <span className="team-name">{name}</span></span>
    </div>
  );
}
